import * as React from 'react';

import { cn, Select } from '@rematter/ui-web';
import { getTimeZones } from '@vvo/tzdb';

import { EntitySelectProps } from '~/shared/components/select-fields/types';

export const SelectTimeZone = ({ onChange, ...props }: EntitySelectProps) => {
  const timezoneOptions = React.useMemo(
    () =>
      getTimeZones({ includeUtc: true }).map((tz) => ({
        key: tz.name,
        label: tz.currentTimeFormat,
      })),
    [],
  );

  return (
    <Select
      {...props}
      className={cn('@SelectTimeZone', props.className)}
      options={timezoneOptions}
      onChange={(v) => onChange?.(v, v)}
    />
  );
};
